export default "__VITE_ASSET__CGaZFDNZ__"